module.exports = "/fonts/quark-bold.eot?3f84841ba4aa4df58ab3460dd63519f3";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/fonts/Quark/quark-bold.eot
// module id = sUrW
// module chunks = 0